(function () {
  "use strict";
  var ENDPOINT = "/apps/bb-portal/portal/v1/availability";
  var MATRIX_ENDPOINT = ENDPOINT + "/matrix";
  var WIDGET_SELECTOR = "[data-bb-delivery-date][data-context]";
  var initialized = new WeakSet();
  var deliveryOptionsId = 0;
  /* Set synchronously by bb-summary before this script runs, whenever the page
     was opened as an artwork revision (?bbRevision=...). */
  var REVISION_HYDRATION_TIMEOUT_MS = 8000;

  function revisionHydrating() {
    try {
      return document.documentElement.dataset.bbRevisionHydrating === "1";
    } catch (error) {
      return false;
    }
  }

  function supplierDebugEnabled(root) {
    try {
      return (
        root.dataset.context === "product" &&
        new URLSearchParams(window.location.search).get("debug") === "true"
      );
    } catch (error) {
      return false;
    }
  }

  function productScope(root) {
    return (
      root.closest(
        ".bb-product, .bb-adh, .bb-simple-product, [data-bb-lp], [data-bb-bundle]",
      ) ||
      root.closest("form") ||
      root
    );
  }

  function quantityInputFor(scope) {
    return (
      scope.querySelector('[data-bb-active-quantity="true"]') ||
      scope.querySelector(
        'input[name="quantity"], select[name="quantity"], .bb-qty-input, .bb-adh-qty__input',
      )
    );
  }

  function hasInvalidLanyardQuantity(root) {
    var scope = productScope(root);
    return (
      scope.dataset.bbLanyardQuantityValid === "false" &&
      Object.prototype.hasOwnProperty.call(
        scope.dataset,
        "bbSupportedQuantities",
      )
    );
  }

  function hideForInvalidLanyardQuantity(root) {
    clearSelection(root);
    root.classList.remove("is-loading");
    root.hidden = true;
    root.dataset.deliveryRequired = "true";
    root.dataset.deliveryValid = "false";
    setStatus(root, "");
    publishPending(root, true, true);
    return null;
  }

  function quantityFor(root) {
    if (root.dataset.context === "cart") {
      return Math.max(1, Number(root.dataset.initialQuantity) || 1);
    }
    var scope = productScope(root);
    var input = quantityInputFor(scope);
    return Math.max(1, Number(input && input.value) || 1);
  }

  function configurationFor(root) {
    if (root.dataset.context === "cart") {
      var propertiesNode = root.querySelector("[data-bb-delivery-properties]");
      var cartProperties = {};
      try {
        cartProperties =
          JSON.parse((propertiesNode && propertiesNode.textContent) || "{}") ||
          {};
      } catch (error) {
        cartProperties = {};
      }
      return Object.keys(cartProperties).reduce(function (result, name) {
        if (
          name !== "Delivery date" &&
          name.charAt(0) !== "_" &&
          name.indexOf("Color: ") !== 0
        ) {
          result[name] = cartProperties[name];
        }
        return result;
      }, {});
    }
    var scope = productScope(root);
    var configuration = {};
    scope.querySelectorAll('[name^="properties\\["]').forEach(function (input) {
      if (
        (input.type === "radio" || input.type === "checkbox") &&
        !input.checked
      )
        return;
      var name = (input.name.match(/^properties\[(.*)\]$/) || [])[1];
      if (
        !name ||
        name === "Delivery date" ||
        name.charAt(0) === "_" ||
        name.indexOf("Color: ") === 0
      ) {
        return;
      }
      configuration[name] = input.value;
    });
    var onSitePrinting = String(
      configuration["On-Site Printing"] || "",
    ).toLowerCase();
    if (onSitePrinting === "yes-color") {
      configuration["Printer compatibility"] = "Epson";
    } else if (onSitePrinting === "no-mono") {
      configuration["Printer compatibility"] = "Zebra";
    }
    return configuration;
  }

  function pricingConfigurationFor(root) {
    var configuration = configurationFor(root);
    if (
      root.dataset.context !== "product" ||
      !window.BadgeBuzzPricingMatrix ||
      !window.BadgeBuzzProductOptionCatalog
    ) {
      return configuration;
    }
    var node = root.querySelector("[data-bb-pricing-matrix-context]");
    var context;
    try {
      context = JSON.parse((node && node.textContent) || "null");
    } catch (error) {
      return configuration;
    }
    var definition =
      context && window.BadgeBuzzProductOptionCatalog.get(context.handle);
    return definition
      ? window.BadgeBuzzPricingMatrix.canonicalConfiguration(
          definition,
          configuration,
        )
      : configuration;
  }

  function variantGidFor(root) {
    if (root.dataset.context === "cart") return root.dataset.variantGid;
    var scope = productScope(root);
    if (scope.matches("[data-bb-lp]")) {
      var selectedId = String(scope.getAttribute("data-variant-id") || "")
        .replace(/\D/g, "");
      if (selectedId) {
        return "gid://shopify/ProductVariant/" + selectedId;
      }
    }
    var input = scope.querySelector('[name="id"]');
    var id = String((input && input.value) || "").replace(/\D/g, "");
    if (input) {
      return id ? "gid://shopify/ProductVariant/" + id : "";
    }
    return root.dataset.variantGid;
  }

  function money(value, currency) {
    if (window.BadgeBuzzMoney) {
      return window.BadgeBuzzMoney.format(value, {
        currency: currency || "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
    }).format(Number(value));
  }

  function interpolate(template, replacements) {
    return Object.keys(replacements).reduce(function (result, key) {
      return result.split("__" + key + "__").join(replacements[key]);
    }, template);
  }

  function updateHeading(root) {
    if (root.dataset.context === "cart") return;
    var heading = root.querySelector("[data-bb-delivery-heading]");
    var quantityInput = quantityInputFor(productScope(root));
    var quantity = Number(quantityInput && quantityInput.value);
    if (!heading || !Number.isInteger(quantity) || quantity < 1) return;
    heading.textContent = interpolate(
      root.dataset.headingTemplate ||
        "Ready-to-ship options for __QUANTITY__ badges",
      { QUANTITY: String(quantity) },
    );
  }

  function syncReadiness(root) {
    if (window.BBProductActionReadiness) {
      window.BBProductActionReadiness.sync(productScope(root));
    }
  }

  function dispatchProductPricingEvent(root, name, detail) {
    if (root.dataset.context !== "product") return;
    productScope(root).dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: detail }),
    );
  }

  function syncNativeStockPresentation(root, nativeStock) {
    var scope = productScope(root);
    scope
      .querySelectorAll("[data-bb-sum-delivery], [data-bb-rail-delivery]")
      .forEach(function (element) {
        var row = element.closest(".bb-summary__row, .bb-product-sticky__row");
        if (row) row.hidden = nativeStock;
      });
    scope.querySelectorAll("[data-bb-summary-note]").forEach(function (note) {
      if (!note.dataset.bbDeliveryNote) {
        note.dataset.bbDeliveryNote = note.textContent.trim();
      }
      note.textContent = nativeStock
        ? "Shipping and taxes are calculated at checkout."
        : note.dataset.bbDeliveryNote;
    });
  }

  function renderPriceSummary(root, data) {
    renderSelectedPrice(root, null);
    var output = root.querySelector("[data-bb-delivery-price]");
    if (!output) return;
    var exact = data.pricing_strategy === "shopify_native";
    syncNativeStockPresentation(root, exact);
    if (data.from_total == null || data.pricing_state !== "ready") {
      output.textContent =
        root.dataset.pricingUnavailableLabel ||
        "Pricing is not available for this configuration.";
      output.hidden = false;
      return;
    }
    output.textContent =
      (exact ? "" : "From ") +
      money(data.from_total, data.currency) +
      " total · " +
      money(data.from_unit, data.currency) +
      " each";
    output.hidden = false;
    publishPrice(
      root,
      Number(data.from_total),
      Number(data.from_unit),
      exact,
    );
  }

  function publishPrice(root, total, perUnit, exact) {
    var scope = productScope(root);
    var configuration = pricingConfigurationFor(root);
    var displayConfiguration = configurationFor(root);
    var detail = {
      total: total,
      subtotal: total,
      per_piece: perUnit,
      qty: quantityFor(root),
      currency: root.dataset.currency || "USD",
      exact: exact,
      authoritative: true,
      material: configuration.Material || configuration.material || "",
      size: configuration.Size || configuration.size || "",
      slots:
        configuration["Perforated Slots"] ||
        configuration.Slots ||
        configuration.slots ||
        "",
      design:
        displayConfiguration.Design || displayConfiguration.design || "",
    };
    var price = scope.querySelector(".bb-qty-price");
    if (price) {
      price.textContent =
        (exact ? "" : "From ") + money(perUnit, detail.currency) + " per piece";
    }
    scope
      .querySelectorAll(
        "[data-bb-total-price], [data-bb-total], [data-bb-sp-total], [data-bb-total-val]",
      )
      .forEach(function (element) {
        element.textContent =
          (exact ? "" : "From ") + money(total, detail.currency);
      });
    scope
      .querySelectorAll(
        "[data-bb-total-sub], [data-bb-unit], [data-bb-sp-unit], [data-bb-total-per]",
      )
      .forEach(function (element) {
        element.textContent = "(" + money(perUnit, detail.currency) + " each)";
        element.hidden = false;
      });
    scope.dataset.bbAuthoritativePricingState = exact ? "selected" : "ready";
    dispatchProductPricingEvent(root, "bb:price-update", detail);
    syncReadiness(root);
  }

  function publishPending(root, unavailable, silent) {
    var scope = productScope(root);
    var loadingLabel = silent
      ? ""
      : root.dataset.pricingLoadingLabel || "Loading pricing…";
    scope.dataset.bbAuthoritativePricingState = unavailable
      ? "unavailable"
      : "loading";
    dispatchProductPricingEvent(root, "bb:price-pending", {
      unavailable: Boolean(unavailable),
      silent: Boolean(silent),
      authoritative: true,
      currency: root.dataset.currency || "USD",
    });
    syncReadiness(root);
    var price = scope.querySelector(".bb-qty-price");
    if (price) {
      price.textContent = unavailable
        ? root.dataset.pricingUnavailableLabel ||
          "Pricing is not available for this configuration."
        : loadingLabel;
    }
    scope
      .querySelectorAll(
        "[data-bb-total-price], [data-bb-total], [data-bb-sp-total], [data-bb-total-val]",
      )
      .forEach(function (element) {
        element.textContent = unavailable
          ? "Pricing unavailable"
          : loadingLabel;
      });
    scope
      .querySelectorAll(
        "[data-bb-total-sub], [data-bb-unit], [data-bb-sp-unit], [data-bb-total-per]",
      )
      .forEach(function (element) {
        element.textContent = "";
        element.hidden = true;
      });
  }

  function dateParts(value) {
    var date = new Date(value + "T12:00:00Z");
    return {
      month: new Intl.DateTimeFormat("en", {
        month: "short",
        timeZone: "UTC",
      }).format(date),
      monthYear: new Intl.DateTimeFormat("en", {
        month: "short",
        year: "numeric",
        timeZone: "UTC",
      }).format(date),
      day: new Intl.DateTimeFormat("en", {
        day: "numeric",
        timeZone: "UTC",
      }).format(date),
      weekday: new Intl.DateTimeFormat("en", {
        weekday: "short",
        timeZone: "UTC",
      }).format(date),
      full: new Intl.DateTimeFormat("en", {
        month: "long",
        day: "numeric",
        timeZone: "UTC",
      }).format(date),
    };
  }

  function earliestDeliveryOption(options) {
    return (Array.isArray(options) ? options : []).reduce(function (
      earliest,
      option,
    ) {
      var value = option && String(option.date || "");
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return earliest;
      var parsed = new Date(value + "T00:00:00Z");
      if (
        Number.isNaN(parsed.getTime()) ||
        parsed.toISOString().slice(0, 10) !== value
      ) {
        return earliest;
      }
      return !earliest || value < earliest.date ? option : earliest;
    }, null);
  }

  function setStatus(root, message, error) {
    if (error) renderSelectedPrice(root, null);
    var status = root.querySelector("[data-bb-delivery-status]");
    if (!status) return;
    status.textContent = message || "";
    status.classList.toggle("is-error", Boolean(error));
  }

  function announceSelection(root, value) {
    window.dispatchEvent(
      new CustomEvent("bb:delivery-date-change", {
        detail: { date: value, root: root },
      }),
    );
  }

  function clearSelection(root) {
    [
      "[data-bb-delivery-input]",
      "[data-bb-delivery-offer]",
      "[data-bb-delivery-configuration]",
      "[data-bb-delivery-printing-method]",
    ].forEach(function (selector) {
      var input = root.querySelector(selector);
      if (input) input.value = "";
    });
    root.dataset.deliveryValid = "false";
  }

  function saveCartSelection(root, option, configuration) {
    var propertiesNode = root.querySelector("[data-bb-delivery-properties]");
    var properties = {};
    try {
      properties = JSON.parse(propertiesNode.textContent || "{}") || {};
    } catch (error) {
      properties = {};
    }
    properties["Delivery date"] = option.date;
    if (option.offer) {
      properties["_BadgeBuzz offer"] = option.offer;
    } else {
      delete properties["_BadgeBuzz offer"];
    }
    properties["_BadgeBuzz configuration"] = JSON.stringify(configuration);
    if (option.printing_method_code) {
      properties["_BadgeBuzz printing method"] = option.printing_method_code;
    } else {
      delete properties["_BadgeBuzz printing method"];
    }
    setStatus(root, "Saving ready-to-ship date…");
    return fetch(
      (window.routes && window.routes.cart_change_url) || "/cart/change.js",
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: root.dataset.lineKey,
          quantity: quantityFor(root),
          properties: properties,
        }),
      },
    ).then(function (response) {
      if (!response.ok) throw new Error("Could not update this cart item.");
      if (propertiesNode)
        propertiesNode.textContent = JSON.stringify(properties);
      setStatus(root, "Ready-to-ship date updated.");
      document.dispatchEvent(new CustomEvent("cart:updated"));
    });
  }

  function selectOffer(root, option) {
    var input = root.querySelector("[data-bb-delivery-input]");
    var offerInput = root.querySelector("[data-bb-delivery-offer]");
    var configurationInput = root.querySelector(
      "[data-bb-delivery-configuration]",
    );
    var printingMethodInput = root.querySelector(
      "[data-bb-delivery-printing-method]",
    );
    var configuration = pricingConfigurationFor(root);
    if (input) input.value = option.date;
    if (offerInput) offerInput.value = option.offer || "";
    if (configurationInput) {
      configurationInput.value = JSON.stringify(configuration);
    }
    if (printingMethodInput) {
      printingMethodInput.value = option.printing_method_code || "";
    }
    root.querySelectorAll("[data-delivery-offer]").forEach(function (button) {
      button.setAttribute(
        "aria-pressed",
        String(button.dataset.deliveryDateValue === option.date),
      );
    });
    root.dataset.deliveryValid = "true";
    root.dataset.currency = option.currency || "USD";
    renderSelectedPrice(root, option);
    publishPrice(root, Number(option.total), Number(option.per_unit), true);
    setStatus(root, "");
    announceSelection(root, option.date);
    if (root.dataset.context === "cart") {
      saveCartSelection(root, option, configuration).catch(function (error) {
        root.dataset.deliveryValid = "false";
        setStatus(root, error.message, true);
      });
    }
  }

  function renderSelectedPrice(root, option) {
    var output = root.querySelector("[data-bb-delivery-selected-price]");
    if (!output) return;
    var valid = Boolean(
      option &&
      option.total != null &&
      option.per_unit != null &&
      Number.isFinite(Number(option.total)) &&
      Number.isFinite(Number(option.per_unit)),
    );
    output.hidden = !valid;
    root.classList.toggle("has-selected-price", valid);
    output.textContent = valid
      ? interpolate(
        root.dataset.selectedPriceTemplate || "Selected: __TOTAL__ total · __EACH__ each",
        {
          TOTAL: money(option.total, option.currency),
          EACH: money(option.per_unit, option.currency),
        },
      )
      : "";
  }

  function renderOptionCards(root, options, settings) {
    settings = settings || {};
    var container = root.querySelector("[data-bb-delivery-options]");
    var more = root.querySelector("[data-bb-delivery-more]");
    var current = settings.currentDate || "";
    renderSelectedPrice(root, options.find(function (option) {
      return option.date === current;
    }));
    var hasComparisonOptions = options.length > 1;
    var earliestOption = earliestDeliveryOption(options);
    var earliestDate = earliestOption ? earliestOption.date : "";
    var pricedOptions = options.filter(function (option) {
      return option.total != null && Number.isFinite(Number(option.total));
    });
    var lowestTotal = pricedOptions.length
      ? Math.min.apply(
          null,
          pricedOptions.map(function (option) {
            return Number(option.total);
          }),
        )
      : null;
    container.replaceChildren();
    options.forEach(function (option, index) {
      var parts = dateParts(option.date);
      var arrival = interpolate(
        root.dataset.arrivesByTemplate || "Ready to ship by __DATE__",
        { DATE: parts.full },
      );
      var labels = [];
      if (hasComparisonOptions && option.date === earliestDate) {
        labels.push(root.dataset.earliestLabel || "Earliest");
      }
      if (
        hasComparisonOptions &&
        lowestTotal != null &&
        Number(option.total) === lowestTotal
      ) {
        labels.push(root.dataset.lowestPriceLabel || "Lowest price");
      }
      var priceText = "";
      var accessiblePriceText = "";
      var supplierDebugText = "";
      if (option.total != null && option.per_unit != null) {
        priceText = interpolate(root.dataset.priceTemplate || "__EACH__ each", {
          TOTAL: money(option.total, option.currency),
          EACH: money(option.per_unit, option.currency),
        });
        accessiblePriceText = interpolate(
          root.dataset.fullPriceTemplate || "__TOTAL__ total · __EACH__ each",
          {
            TOTAL: money(option.total, option.currency),
            EACH: money(option.per_unit, option.currency),
          },
        );
      }
      if (
        supplierDebugEnabled(root) &&
        option._debug &&
        typeof option._debug.supplier_name === "string" &&
        typeof option._debug.supplier_code === "string"
      ) {
        supplierDebugText =
          "Supplier: " +
          option._debug.supplier_name.trim() +
          " (" +
          option._debug.supplier_code.trim() +
          ")";
      }
      var button = document.createElement("button");
      button.type = "button";
      button.className = "bb-delivery-date__option";
      button.dataset.deliveryDateValue = option.date;
      button.dataset.deliveryOffer = option.offer || "";
      button.setAttribute("aria-pressed", String(option.date === current));
      button.hidden = index >= 4;
      button.setAttribute(
        "aria-label",
        [arrival, accessiblePriceText, supplierDebugText]
          .concat(labels)
          .filter(Boolean)
          .join(". "),
      );
      if (labels.length) {
        button.classList.add("has-badges");
        var badges = document.createElement("span");
        badges.className = "bb-delivery-date__option-badges";
        labels.forEach(function (label) {
          var badge = document.createElement("span");
          badge.className = "bb-delivery-date__option-badge";
          badge.textContent = label;
          badges.append(badge);
        });
        button.append(badges);
      }
      var month = document.createElement("span");
      month.className = "bb-delivery-date__option-month";
      month.textContent = root.classList.contains("bb-delivery-date--product")
        ? parts.monthYear
        : parts.month;
      button.append(month);
      var day = document.createElement("strong");
      day.className = "bb-delivery-date__option-day";
      day.textContent = parts.day;
      button.append(day);
      var weekday = document.createElement("span");
      weekday.className = "bb-delivery-date__option-weekday";
      weekday.textContent = parts.weekday;
      button.append(weekday);
      if (priceText) {
        var price = document.createElement("span");
        price.className = "bb-delivery-date__option-price";
        price.textContent = priceText;
        button.append(price);
      }
      if (supplierDebugText) {
        var supplier = document.createElement("span");
        supplier.className = "bb-delivery-date__option-supplier";
        supplier.textContent = supplierDebugText;
        button.append(supplier);
      }
      button.addEventListener("click", function () {
        if (typeof settings.onSelect === "function") {
          settings.onSelect(option);
          renderSelectedPrice(root, option);
        }
      });
      container.append(button);
    });
    var moreLabel = root.dataset.moreLabel || "More ready-to-ship dates";
    var lessLabel = root.dataset.lessLabel || "Show fewer dates";
    if (more) {
      if (!container.id) {
        deliveryOptionsId += 1;
        container.id = "bb-delivery-options-" + deliveryOptionsId;
      }
      more.hidden = options.length <= 4;
      more.dataset.expanded = "false";
      more.setAttribute("aria-controls", container.id);
      more.setAttribute("aria-expanded", "false");
      more.textContent = moreLabel;
      more.onclick = function () {
        var expanded = more.dataset.expanded !== "true";
        more.dataset.expanded = String(expanded);
        more.setAttribute("aria-expanded", String(expanded));
        container
          .querySelectorAll("[data-delivery-date-value]")
          .forEach(function (button, index) {
            button.hidden = !expanded && index >= 4;
          });
        more.textContent = expanded ? lessLabel : moreLabel;
      };
    }
    return { earliestOption: earliestOption };
  }

  function renderOptions(root, options) {
    var input = root.querySelector("[data-bb-delivery-input]");
    var offerInput = root.querySelector("[data-bb-delivery-offer]");
    var current = input ? input.value : "";
    var currentOffer = offerInput ? offerInput.value : "";
    var rendered = renderOptionCards(root, options, {
      currentDate: current,
      onSelect: function (option) {
        selectOffer(root, option);
      },
    });
    var earliestOption = rendered.earliestOption;
    root.dataset.deliveryRequired = "true";
    var currentOption =
      current &&
      options.find(function (option) {
        return option.date === current;
      });
    root.dataset.deliveryValid = String(Boolean(currentOption));
    if (currentOption && root.dataset.context !== "cart") {
      if (offerInput) offerInput.value = currentOption.offer || "";
      var currentConfiguration = root.querySelector(
        "[data-bb-delivery-configuration]",
      );
      if (currentConfiguration) {
        currentConfiguration.value = JSON.stringify(pricingConfigurationFor(root));
      }
      var currentPrintingMethod = root.querySelector(
        "[data-bb-delivery-printing-method]",
      );
      if (currentPrintingMethod) {
        currentPrintingMethod.value = currentOption.printing_method_code || "";
      }
      root.dataset.currency = currentOption.currency || "USD";
      renderSelectedPrice(root, currentOption);
      publishPrice(
        root,
        Number(currentOption.total),
        Number(currentOption.per_unit),
        true,
      );
    }
    if (!currentOption && earliestOption && root.dataset.context !== "cart") {
      selectOffer(root, earliestOption);
      return;
    }
    if ((current || currentOffer) && root.dataset.deliveryValid !== "true") {
      setStatus(
        root,
        "That date is no longer available. Choose a replacement before continuing.",
        true,
      );
    }
  }

  function renderLoadingOptions(root) {
    renderSelectedPrice(root, null);
    var container = root.querySelector("[data-bb-delivery-options]");
    var more = root.querySelector("[data-bb-delivery-more]");
    var fragment = document.createDocumentFragment();
    if (!container) return;
    for (var index = 0; index < 4; index += 1) {
      var skeleton = document.createElement("span");
      skeleton.className = "bb-delivery-date__skeleton";
      skeleton.setAttribute("aria-hidden", "true");
      fragment.append(skeleton);
    }
    container.replaceChildren(fragment);
    if (more) more.hidden = true;
  }

  function normalizedSupportedQuantities(values) {
    var quantities = new Set();
    (Array.isArray(values) ? values : []).forEach(function (value) {
      var quantity = Number(value);
      if (Number.isInteger(quantity) && quantity > 0) {
        quantities.add(quantity);
      }
    });
    return Array.from(quantities).sort(function (left, right) {
      return left - right;
    });
  }

  function syncQuantitySelect(root, values) {
    if (root.dataset.context === "cart") return false;
    var select = productScope(root).querySelector(
      'select[name="quantity"].bb-quantity-select',
    );
    if (!select) return false;
    var quantities = normalizedSupportedQuantities(values);
    var previousQuantity = Number(select.value);
    var signature = quantities.join(",");
    var scope = productScope(root);
    var checkpointsChanged = scope.dataset.bbSupportedQuantities !== signature;
    scope.dataset.bbSupportedQuantities = signature;
    if (select.dataset.supportedQuantities !== signature) {
      var fragment = document.createDocumentFragment();
      if (quantities.length) {
        quantities.forEach(function (quantity) {
          var option = document.createElement("option");
          option.value = String(quantity);
          option.textContent = String(quantity);
          fragment.append(option);
        });
      } else {
        var unavailable = document.createElement("option");
        unavailable.value = "";
        unavailable.textContent =
          root.dataset.quantityUnavailableLabel || "Pricing unavailable";
        fragment.append(unavailable);
      }
      select.replaceChildren(fragment);
      select.dataset.supportedQuantities = signature;
    }
    select.disabled = quantities.length === 0;
    if (checkpointsChanged) {
      scope.dispatchEvent(
        new CustomEvent("bb:supported-quantities-change", {
          bubbles: true,
          detail: { quantities: quantities.slice() },
        }),
      );
    }
    if (!quantities.length) {
      select.value = "";
      return false;
    }
    var nextQuantity = quantities.includes(previousQuantity)
      ? previousQuantity
      : quantities[0];
    select.value = String(nextQuantity);
    return nextQuantity !== previousQuantity;
  }

  function applyAvailability(root, data, reload) {
    root.classList.remove("is-loading");
    root.dataset.currency = data.currency || "USD";
    var quantityChanged = syncQuantitySelect(root, data.supported_quantities);
    if (hasInvalidLanyardQuantity(root)) {
      return hideForInvalidLanyardQuantity(root);
    }
    updateHeading(root);
    if (quantityChanged) {
      return reload();
    }
    var minimumQuantity = Number(data.minimum_quantity);
    var quantityInput = quantityInputFor(productScope(root));
    if (
      quantityInput &&
      quantityInput.tagName !== "SELECT" &&
      !quantityInput.readOnly &&
      Number.isInteger(minimumQuantity) &&
      minimumQuantity > 0
    ) {
      quantityInput.min = String(minimumQuantity);
      if (Number(quantityInput.value) < minimumQuantity) {
        quantityInput.value = String(minimumQuantity);
        return reload();
      }
    }
    renderPriceSummary(root, data);
    if (
      !data.required ||
      !Array.isArray(data.options) ||
      !data.options.length
    ) {
      if (data.required) {
        root.hidden = false;
        root.dataset.deliveryRequired = "true";
        root.dataset.deliveryValid = "false";
        var container = root.querySelector("[data-bb-delivery-options]");
        var priceOutput = root.querySelector("[data-bb-delivery-price]");
        if (container) container.replaceChildren();
        if (priceOutput) {
          priceOutput.textContent = "";
          priceOutput.hidden = true;
        }
        setStatus(
          root,
          interpolate(
            root.dataset.noOptionsTemplate ||
              "No ready-to-ship dates are available for __QUANTITY__ badges with these options. Choose another quantity.",
            { QUANTITY: String(quantityFor(root)) },
          ),
          true,
        );
        publishPending(root, true);
      } else {
        root.hidden = true;
        root.dataset.deliveryRequired = "false";
        root.dataset.deliveryValid = "true";
        syncReadiness(root);
      }
      return null;
    }
    renderOptions(root, data.options);
    var input = root.querySelector("[data-bb-delivery-input]");
    if (root.dataset.deliveryValid === "true" || !input || !input.value) {
      setStatus(root, "");
    }
    return null;
  }

  function matrixSetup(root) {
    if (
      root.dataset.context !== "product" ||
      !window.BadgeBuzzPricingMatrix ||
      !window.BadgeBuzzProductOptionCatalog
    )
      return null;
    var node = root.querySelector("[data-bb-pricing-matrix-context]");
    var context;
    try {
      context = JSON.parse((node && node.textContent) || "null");
    } catch (error) {
      return null;
    }
    var definition =
      context && window.BadgeBuzzProductOptionCatalog.get(context.handle);
    if (!definition || definition.pdpPricingMatrix === false) return null;
    var candidates = window.BadgeBuzzPricingMatrix.buildCandidates(
      context,
      definition,
    );
    if (!candidates.length) return null;
    return { context: context, definition: definition, candidates: candidates };
  }

  function matrixEntryFor(root) {
    var state = root.bbPricingMatrixState;
    if (!state || !state.data) return null;
    var key = window.BadgeBuzzPricingMatrix.configurationKey(
      state.setup.definition,
      configurationFor(root),
    );
    return (
      state.data.configurations.find(function (entry) {
        return entry && entry.key === key;
      }) || null
    );
  }

  function renderMatrixOptions(root) {
    var state = root.bbPricingMatrixState;
    var entry = matrixEntryFor(root);
    if (!state || !entry) return loadExactOptions(root);
    var quantities = normalizedSupportedQuantities(entry.supported_quantities);
    var quantityChanged = syncQuantitySelect(root, quantities);
    if (hasInvalidLanyardQuantity(root)) {
      return Promise.resolve(hideForInvalidLanyardQuantity(root));
    }
    if (quantityChanged) {
      return renderMatrixOptions(root);
    }
    var data = entry.quantities && entry.quantities[String(quantityFor(root))];
    data = Object.assign(
      {
        required: state.data.required,
        options: [],
        supported_quantities: quantities,
        minimum_quantity: quantities[0] || null,
        pricing_state: "unavailable",
      },
      data || {},
      { supported_quantities: quantities },
    );
    return Promise.resolve(
      applyAvailability(root, data, function () {
        return renderMatrixOptions(root);
      }),
    );
  }

  function loadMatrixOptions(root, setup) {
    return fetch(MATRIX_ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        product_gid: root.dataset.productGid,
        candidates: setup.candidates,
        debug: supplierDebugEnabled(root) ? true : undefined,
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (
            !response.ok ||
            data.version !== 1 ||
            !Array.isArray(data.configurations)
          ) {
            throw new Error(data.error || "Pricing matrix failed");
          }
          return data;
        });
      })
      .then(function (data) {
        root.bbPricingMatrixState = { setup: setup, data: data };
        return renderMatrixOptions(root);
      });
  }

  function loadExactOptions(root) {
    var configuration = pricingConfigurationFor(root);
    var configurationKey = JSON.stringify(Object.keys(configuration).sort().map(function (key) {
      return [key, configuration[key]];
    }));
    var configurationChanged = typeof root.bbExactPricingConfiguration === "string" &&
      root.bbExactPricingConfiguration !== configurationKey;
    if (hasInvalidLanyardQuantity(root) && !configurationChanged) {
      return Promise.resolve(hideForInvalidLanyardQuantity(root));
    }
    // A failed matrix may leave empty/stale checkpoints. New choices must be
    // allowed to discover their own quantities through the exact fallback.
    root.classList.add("is-loading");
    root.hidden = false;
    updateHeading(root);
    publishPending(root, false, false);
    renderLoadingOptions(root);
    setStatus(root, "Loading pricing…");
    return fetch(ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        product_gid: root.dataset.productGid,
        variant_gid: variantGidFor(root),
        quantity: quantityFor(root),
        configuration: configuration,
        designs: 1,
        delivery_date:
          (root.querySelector("[data-bb-delivery-input]") &&
            root.querySelector("[data-bb-delivery-input]").value) ||
          null,
        debug: supplierDebugEnabled(root) ? true : undefined,
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok)
            throw new Error(data.error || "Availability failed");
          return data;
        });
      })
      .then(function (data) {
        root.bbExactPricingConfiguration = configurationKey;
        return applyAvailability(root, data, function () {
          return loadExactOptions(root);
        });
      })
      .catch(function () {
        root.classList.remove("is-loading");
        root.hidden = false;
        root.dataset.deliveryRequired = "true";
        root.dataset.deliveryValid = "false";
        renderPriceSummary(root, {
          pricing_state: "unavailable",
          from_total: null,
        });
        publishPending(root, true);
        setStatus(
          root,
          root.dataset.pricingErrorLabel ||
            "Current pricing could not be loaded. Please try again.",
          true,
        );
      });
  }

  function loadOptions(root) {
    // A different configuration may allow quantities the previous one rejected.
    // Refresh its matrix checkpoints before applying quantity validity.
    if (root.bbPricingMatrixState) return renderMatrixOptions(root);
    if (root.bbPricingMatrixPromise) return root.bbPricingMatrixPromise;
    var setup = matrixSetup(root);
    if (!setup || root.bbPricingMatrixFailed) return loadExactOptions(root);
    root.classList.add("is-loading");
    root.hidden = false;
    updateHeading(root);
    publishPending(root, false, true);
    renderLoadingOptions(root);
    setStatus(root, "");
    root.bbPricingMatrixPromise = loadMatrixOptions(root, setup)
      .catch(function () {
        root.bbPricingMatrixFailed = true;
        return loadExactOptions(root);
      })
      .finally(function () {
        root.bbPricingMatrixPromise = null;
      });
    return root.bbPricingMatrixPromise;
  }

  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    var timer;
    var scope = productScope(root);
    var quantityInput = quantityInputFor(scope);
    var refreshAfterInteraction = function (delay) {
      window.clearTimeout(timer);
      clearSelection(root);
      updateHeading(root);
      announceSelection(root, "");
      if (root.bbPricingMatrixState) {
        return renderMatrixOptions(root);
      }
      publishPending(root, false, false);
      root.classList.add("is-loading");
      renderLoadingOptions(root);
      setStatus(root, "Loading pricing…");
      timer = window.setTimeout(function () {
        loadOptions(root);
      }, delay);
      return null;
    };
    if (
      quantityInput &&
      quantityInput.tagName !== "SELECT" &&
      root.dataset.context !== "cart"
    ) {
      quantityInput.addEventListener("input", function () {
        refreshAfterInteraction(220);
      });
    }
    if (root.dataset.context !== "cart") {
      scope.addEventListener("bb:configuration-update", function () {
        refreshAfterInteraction(0);
      });
      scope.addEventListener("change", function (event) {
        if (
          event.target.closest(WIDGET_SELECTOR) ||
          event.target.matches('input[type="file"]') ||
          !event.target.matches("input, select")
        )
          return;
        refreshAfterInteraction(120);
      });
      scope.addEventListener("click", function (event) {
        if (
          !event.target.closest(
            "[data-bb-material-track] button, [data-bb-sides] button, .bb-optcard, .bb-visual-radio-btn",
          )
        )
          return;
        refreshAfterInteraction(120);
      });
    }

    if (!revisionHydrating()) {
      loadOptions(root);
      return;
    }
    /* An artwork revision prefills quantity and product options from the paid
       order a moment after load. Pricing now would quote an empty
       configuration and flash "no delivery dates are available" before the
       real answer arrives, so wait for the prefill and make one request. */
    renderLoadingOptions(root);
    setStatus(root, "Loading the options from your order…");
    var revisionStarted = false;
    var startAfterRevision = function () {
      if (revisionStarted) return;
      revisionStarted = true;
      window.removeEventListener("bb:revision-hydrated", startAfterRevision);
      loadOptions(root);
    };
    window.addEventListener("bb:revision-hydrated", startAfterRevision);
    /* Never let a failure upstream leave the delivery picker blank forever. */
    window.setTimeout(startAfterRevision, REVISION_HYDRATION_TIMEOUT_MS);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll(WIDGET_SELECTOR).forEach(initialize);
  }

  window.BadgeBuzzDeliveryDateUI = Object.assign(
    {},
    window.BadgeBuzzDeliveryDateUI || {},
    {
      earliestDeliveryOption: earliestDeliveryOption,
      renderLoadingOptions: renderLoadingOptions,
      renderOptionCards: renderOptionCards,
      renderSelectedPrice: renderSelectedPrice,
    },
  );

  document.addEventListener(
    "click",
    function (event) {
      var action = event.target.closest(
        "[data-bb-sp-add], [data-bb-add], .product-form__submit",
      );
      if (!action) return;
      var actionScope = action.closest(
        ".bb-product, .bb-adh, .bb-simple-product, [data-bb-lp], [data-bb-bundle]",
      );
      if (!actionScope) return;
      var roots = Array.from(
        actionScope.querySelectorAll(WIDGET_SELECTOR),
      );
      var invalid = roots.find(function (root) {
        return (
          !root.hidden &&
          root.dataset.deliveryRequired === "true" &&
          root.dataset.deliveryValid !== "true"
        );
      });
      if (!invalid) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setStatus(invalid, "Choose a ready-to-ship date before continuing.", true);
      invalid.scrollIntoView({ behavior: "smooth", block: "center" });
      var first = invalid.querySelector("[data-delivery-date-value]");
      if (first) first.focus();
    },
    true,
  );
  document.addEventListener(
    "submit",
    function (event) {
      if (!event.target.matches('form[action*="/cart/add"]')) return;
      var invalid = Array.from(
        event.target.querySelectorAll(WIDGET_SELECTOR),
      ).find(function (root) {
        return (
          !root.hidden &&
          root.dataset.deliveryRequired === "true" &&
          root.dataset.deliveryValid !== "true"
        );
      });
      if (!invalid) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setStatus(invalid, "Choose a ready-to-ship date before continuing.", true);
      invalid.scrollIntoView({ behavior: "smooth", block: "center" });
      var first = invalid.querySelector("[data-delivery-date-value]");
      if (first) first.focus();
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    initializeAll(event.target);
  });
  document.addEventListener("cart:updated", function () {
    initializeAll(document);
  });
})();
